export interface PaymentMethod {

  id: number;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string;
  icon: string;
  color: string;
  type: Type;
}

export enum Type {
  SWISH = "SWISH",
  CARD = "CARD",
  INVOICE_PRINT = "INVOICE_PRINT",
  INVOICE_EMAIL = "INVOICE_EMAIL",
  INVOICE_POST = "INVOICE_POST",
  PAYLINK_SMS = "PAYLINK_SMS",
}
